import React, { useRef, useState } from 'react';
import { Carousel, Empty, Image, Modal, Space } from 'antd';
import Slider from 'react-slick';
import Step1 from 'assets/img/invitations/instruction-step1.png';
import Step2 from 'assets/img/invitations/instruction-step2.png';
import Step3 from 'assets/img/invitations/instruction-step3.png';
import styled from 'styled-components';
import { AButton } from 'components/Antd';

const StyledEmpty = styled(Empty)`
  .ant-empty-image {
    height: 226px;
  }
`;

const StyledFooter = styled(Space)`
  display: flex;
  flex: 1;
`;

const Title = styled.h3`
  color: var(--text-text-600, #232b3a);
  text-align: center;

  /* Header/H2 - Medium */
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 120% */
  letter-spacing: 0.2px;
`;

const StyledCurrentStep = styled.span`
  color: var(--text-text-300, #8991a0);

  /* Body/Caption 1 - Regular */
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px; /* 120% */
  letter-spacing: 0.1px;
`;

const Description = styled.p`
  color: var(--text-text-400, #4e5a71);
  text-align: center;

  /* Body/Body 2 - Regular */
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  letter-spacing: 0.028px;
`;

const StyledCarousel = styled(Carousel)`
  padding-block: 24px;
  .slick-dots {
    bottom: 0;
    > li > button {
      width: 4px;
      height: 4px;
      border-radius: 4px;
      background: var(--brand-colours-blue-100, #005eff);
      opacity: 0.5;
      cursor: default;
      pointer-events: none !important;
    }
    .slick-active {
      width: 12px;
      height: 4px;
      border-radius: 4px;
      background: var(--brand-colours-blue-100, #005eff);
      opacity: 1;
      color: #005eff;
      > button {
        background: var(--brand-colours-blue-100, #005eff) !important;
      }
    }
  }
`;

const InvitationIntro = ({ open, invitationName, onSubmit }) => {
  const refCarousel = useRef();
  const [currentStep, setCurrentStep] = useState(0);

  const steps = [
    {
      title: '',
      content: (
        <StyledEmpty
          description={
            <Space direction="vertical">
              <Title>Invitation Accepted</Title>
              <Description>
                Viewing intro to know what you can do after connected with Buyer.
              </Description>
            </Space>
          }
          image={<Image preview={false} src={Step1} />}
        />
      ),
    },
    {
      title: '',
      content: (
        <StyledEmpty
          description={
            <Space direction="vertical">
              <Title>Viewing Partner’s Products</Title>
              <Description>
                Mitsubishi Electric Corporation is connect as your partner! You can view partner’s
                product.
              </Description>
            </Space>
          }
          image={<Image preview={false} src={Step2} />}
        />
      ),
    },
    {
      title: '',
      content: (
        <StyledEmpty
          description={
            <Space direction="vertical">
              <Title>Create Compliance Related Jobs on Behalf of this Buyer</Title>
              <Description>Can manage job on behalf of the Buyer.</Description>
            </Space>
          }
          image={<Image preview={false} src={Step3} />}
        />
      ),
    },
  ];
  return (
    <Modal
      open={open}
      width={640}
      closable={false}
      title={
        <Space>
          Partner Connection Introduction step
          <StyledCurrentStep>Step {currentStep + 1} of 3</StyledCurrentStep>
        </Space>
      }
      footer={
        <StyledFooter>
          <AButton
            type="link"
            onClick={() => {
              if (currentStep < 1) {
                onSubmit();
                return;
              }
              refCarousel.current.prev();
            }}>
            {currentStep < 1 ? 'Skip Intro' : 'Back'}
          </AButton>
          <AButton
            type="primary"
            onClick={() => {
              if (currentStep > 1) {
                onSubmit();
                return;
              }
              refCarousel.current.next();
            }}>
            {currentStep > 1 ? 'Done' : 'Continue'}
          </AButton>
        </StyledFooter>
      }>
      <StyledCarousel
        ref={refCarousel}
        fade
        beforeChange={(_current, next) => {
          setCurrentStep(next);
        }}>
        {steps.map(({ content }, index) => (
          <div key={index}>{content}</div>
        ))}
      </StyledCarousel>
    </Modal>
  );
};

export default InvitationIntro;
